// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckCircleFilledSvg from "@fishx/icons-svg/es/asn/CheckCircleFilled";
import FishxIcon from '../components/FishxIcon';

var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleFilledSvg
  }));
};

CheckCircleFilled.displayName = 'CheckCircleFilled';
export default React.forwardRef(CheckCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckCircleFilled.js
// module id = 2192
// module chunks = 0